export const WHATSAPP_ONBOARDING_MODES = {
    CLOUD_API: "cloud_api",
    COEXISTENCE: "coexistence",
}

export const parseEmbeddedSignupEvent = (event) => {
    if (!event?.origin?.endsWith("facebook.com")) return null

    try {
        const payload = typeof event.data === "string" ? JSON.parse(event.data) : event.data
        return payload?.type === "WA_EMBEDDED_SIGNUP" ? payload : null
    } catch (err) {
        return null
    }
}

export const getEmbeddedSignupConfig = (configId, onboardingMode, reauthorize = false) => ({
    config_id: configId,
    response_type: "code",
    override_default_response_type: true,
    ...(onboardingMode === WHATSAPP_ONBOARDING_MODES.COEXISTENCE ? {
        extras: {
            setup: {},
            featureType: "whatsapp_business_app_onboarding",
            sessionInfoVersion: "3",
        }
    } : {}),
    ...(reauthorize ? { auth_type: "rerequest" } : {}),
})
